import type { Template } from "@/types";

export const PO_06_H2_V4: Template[] = [
    {
        id: "po-06-h2v4-01",
        name: "PO 01 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 44, y: 224, width: 236, height: 403, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 287, y: 224, width: 259, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 287, y: 430, width: 259, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 640, y: 163, width: 331, height: 524, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 163, width: 163, height: 258, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 429, width: 163, height: 258, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-02",
        name: "PO 02 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 131, y: 163, width: 335, height: 524, rotation: 0, imageRotation: 0 },
            { id: "2", x: 651, y: 163, width: 358, height: 258, rotation: 0, imageRotation: 0 },
            { id: "3", x: 651, y: 429, width: 358, height: 258, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1017, y: 163, width: 108, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 341, width: 108, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1017, y: 518, width: 108, height: 169, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-03",
        name: "PO 03 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_03.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 46, y: 224, width: 248, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 224, width: 247, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 430, width: 247, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 700, y: 224, width: 253, height: 402, rotation: 0, imageRotation: 0 },
            { id: "5", x: 961, y: 224, width: 124, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 961, y: 429, width: 124, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-04",
        name: "PO 04 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 71, y: 187, width: 453, height: 297, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 71, y: 492, width: 108, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 187, y: 492, width: 108, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 303, y: 492, width: 107, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 418, y: 492, width: 107, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 742, y: 187, width: 300, height: 475, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-05",
        name: "PO 05 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 62, y: 429, width: 473, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 89, width: 233, height: 332, rotation: 0, imageRotation: 0 },
            { id: "3", x: 303, y: 89, width: 233, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 657, y: 89, width: 472, height: 332, rotation: 0, imageRotation: 0 },
            { id: "5", x: 657, y: 429, width: 233, height: 332, rotation: 0, imageRotation: 0 },
            { id: "6", x: 898, y: 429, width: 232, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-06",
        name: "PO 06 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 48, y: 159, width: 497, height: 337, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 48, y: 504, width: 119, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 175, y: 504, width: 119, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 302, y: 504, width: 118, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 428, y: 504, width: 118, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 642, y: 244, width: 502, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-07",
        name: "PO 07 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_07.png",
        size: [1190, 850],
        style: {},
        slots: [        
            { id: "1", x: 48, y: 159, width: 161, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 431, width: 161, height: 263, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 431, width: 161, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 386, y: 431, width: 161, height: 263, rotation: 0, imageRotation: 0 },
            { id: "5", x: 217, y: 159, width: 330, height: 264, rotation: 0, imageRotation: 0 },
            { id: "6", x: 642, y: 244, width: 502, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-08",
        name: "PO 08 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 595, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 658, y: 165, width: 350, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 658, y: 429, width: 350, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1015, y: 165, width: 105, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1015, y: 341, width: 105, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1015, y: 517, width: 105, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-09",
        name: "PO 09 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_09.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 45, y: 144, width: 173, height: 278, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 430, width: 173, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 226, y: 144, width: 791, height: 563, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1025, y: 144, width: 115, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1025, y: 335, width: 115, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1025, y: 525, width: 115, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-10",
        name: "PO 10 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 56, y: 169, width: 671, height: 512, rotation: 0, imageRotation: 0 },
            { id: "2", x: 734, y: 169, width: 196, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 938, y: 169, width: 196, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 481, width: 128, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 870, y: 481, width: 128, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1006, y: 481, width: 128, height: 201, rotation: 0, imageRotation: 0 }
        ],
    }
];